import InversorList from './InversorList'

export default {
  list: InversorList,
}
